import { NgModule } from '@angular/core';
import { ListviewCustomerComponent } from './listview-customer.component';
import { LayoutModule, FuseSharedModule } from 'sp-office365-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFrameworkModule } from 'sp-office365-framework';

const routes = [
    {
        path: 'customers',
        component: ListviewCustomerComponent,
    },
];

@NgModule({
    declarations: [ListviewCustomerComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        AngularFrameworkModule,
    ],
    exports: [ListviewCustomerComponent],
})
export class ListviewCustomerModule {}
